export const tr = {
    campaign: 'Kampanya',
    name: 'Ad',
    status: 'Durum',
    type: 'Tür'
};
